import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-enable-shipment',
  templateUrl: './modal-enable-shipment.component.html',
  styleUrls: ['./modal-enable-shipment.component.css']
})
export class ModalEnableShipmentComponent implements OnInit {

  filter = 'none';
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }


  changeFilter(value) {
    this.filter = value
  }

  confirm() {
    const data = {
      confirm: true,
      filter: this.filter
    }

    this.activeModal.dismiss(data);
  }

}
